(function () {
    'use strict';
    var controllerId = 'orderListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modal', '$routeParams', '$cookies', 'NgTableParams', orderListCtrl]);

    function orderListCtrl(common, datacontext, $scope, $location, $modal, $routeParams, $cookies, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.startSearch = 0;

        vm.default_user_order_age = $cookies.get('default_user_order_age');
        if(vm.default_user_order_age === '' || vm.default_user_order_age === 'undefined' || vm.default_user_order_age === undefined){
            vm.default_user_order_age = 3;
        }

		vm.premium_today_onsite = $cookies.get('premium_today_onsite');
		if(vm.premium_today_onsite === '' || vm.premium_today_onsite === 'undefined' || vm.premium_today_onsite === undefined){
            $cookies.put('premium_today_onsite','0');
        }

        vm.orders = [];
        vm.title = 'Order List View';
        if(angular.isDefined($routeParams.nopl_orders)){
          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1,5,6",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  warehouse_id: "4",
                  order_age: "",
                  order_age2:"90",
                  sales_channel:"",
                  order_by: "default",
                  sort_order_by: "mp_ship_latest_by",
                  picklist_id: "200",
                  ship_method_id: "",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  amazon_prime: "0",
                  amz_promo: "",
                  sfp_alert: "0",
                  today:"3",
                  page: 1,
                  limit: 40
              };

        }else if(angular.isDefined($routeParams.onsite_unshipped)){
          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  warehouse_id: "6",
                  order_age: "100",
                  order_age2:"90",
                  sales_channel:"",
                  order_by: "premiumtoday",
                  sort_order_by: "pickpack_slip_id",
                  ship_method_id: "SecondDay",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  amazon_prime: "0",
                  amz_promo: "",
                  sfp_alert: "0",
                  page: 1,
                  limit: 40
              };

        }else{
          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1,5,6",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  warehouse_id: "4",
                  order_age: "",
                  order_age2:"90",
                  sales_channel:"",
                  order_by: "default",
                  sort_order_by: "mp_ship_latest_by",
                  picklist_id: "300",
                  ship_method_id: "",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  amazon_prime: "0",
                  amz_promo: "",
                  sfp_alert: "0",
                  today:"3",
                  page: 1,
                  limit: 40
              };

        }

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	for ( var i in newValue ) {


                if ( i !== 'page' && newValue[i] !== oldValue[i]) {

                	console.log(i, newValue[i], oldValue[i]);

                    if(i === 'order_age'){
                        $cookies.put('default_user_order_age',newValue[i]);
                        vm.default_user_order_age = $cookies.get('default_user_order_age');
                    }

                	vm.startSearch ++;
                	if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true || oldValue[i] < 0 || i == 'ship_method_id'){

                		get_orders_list();
                    }else{
                        return "";
                    }
                }
            }

        });

        $scope.reset = function(data) {
          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "",
                  fulfillment_status_id: "",
                  cancel_reason_id: "",
                  order_status_id: "",
                  warehouse_id: "4",
                  order_age: "",
                  order_age2:"90",
                  sales_channel:"",
                  order_by: "mp_ship_latest_by",
                  sort_order_by: "mp_ship_latest_by",
                  ship_method_id: "",
                  order_dir: "asc",
                  order_sub_status_id: "",
                  amazon_prime: "0",
                  amz_promo: "",
                  sfp_alert: "0",
                  page: 1,
                  limit: 40
              };

          get_orders_list();
        };

$scope.premiumtodayonsite = function(data) {

	$cookies.put('default_user_order_age','100');
	vm.default_user_order_age = $cookies.get('default_user_order_age');

	$cookies.put('premium_today_onsite','1');
	vm.premium_today_onsite = $cookies.get('premium_today_onsite');

  vm.query = {
          queryType:'array-count',
          search: "",
          product_id: "",
          store_id: "",
          financial_status_id: "4",
          fulfillment_status_id: "1,5,6",
          cancel_reason_id: "",
          order_status_id: "1",
          warehouse_id: "6", //only onSite
          order_age: "100",
          order_age2:"90",
          picklist_id: "300",
          sales_channel:"",
          order_by: "premiumtoday",
          sort_order_by: "pickpack_slip_id",
          ship_method_id: "SecondDay",
          order_dir: "asc",
          order_sub_status_id: "1",
          amazon_prime: "0", //only onSite
          amz_promo: "",
          sfp_alert: "0",
          todayonsite:"1",
          page: 1,
          limit: 40
      };

  get_orders_list();
};
		
		$scope.wholesaletoship = function(data) {
			vm.query = {
				queryType:'array-count',
				search: "",
				product_id: "",
				store_id: "24",
				financial_status_id: "",
				fulfillment_status_id: "1,5,6",
				cancel_reason_id: "",
				order_status_id: "1",
				warehouse_id: "4", //only onSite
				order_age: "",
				order_age2:"90",
				sales_channel:"",
				order_by: "mp_ship_latest_by",
				sort_order_by: "mp_ship_latest_by",
				ship_method_id: "",
				order_dir: "asc",
				order_sub_status_id: "",
				amazon_prime: "0",
				amz_promo: "",
				sfp_alert: "0",
				todaywholesale:"1",
				today: "",
				page: 1,
				limit: 40
			};

			get_orders_list();
		}

        $scope.premiumtodaysfp = function(data) {
          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1,5,6",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  warehouse_id: "4",
                  order_age: "100",
                  order_age2:"90",
                  sales_channel:"",
                  order_by: "premiumtoday",
                  sort_order_by: "pickpack_slip_id",
                  ship_method_id: "SecondDay",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  amazon_prime: "10", //only SFP
                  amz_promo: "",
                  sfp_alert: "1",
                  todaysfp:"1",
                  page: 1,
                  limit: 40
              };

          get_orders_list();
        };

        $scope.getbylisttype = function(data) {
          vm.query.picklist_id = data;
          get_orders_list();
        };
        $scope.premiumtoday = function(data) {
          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1,5,6",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  warehouse_id: "4",
                  order_age: "100",
                  order_age2:"90",
                  sales_channel:"",
                  order_by: "premiumtoday",
                  sort_order_by: "pickpack_slip_id",
                  ship_method_id: "SecondDay",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  amazon_prime: "9",
                  amz_promo: "",
                  sfp_alert: "0",
                  today:"1",
                  page: 1,
                  limit: 40
              };

          get_orders_list();
        };

        $scope.alltoday = function(data) {

        	$cookies.put('default_user_order_age','100');
        	vm.default_user_order_age = $cookies.get('default_user_order_age');
        	$cookies.put('premium_today_onsite','0');

          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1,5,6",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  warehouse_id: "4",
                  order_age: "100",
                  order_age2:"90",
                  picklist_id: "300",
                  sales_channel:"",
                  order_by: "alltoday",
                  sort_order_by: "mp_ship_latest_by",
                  ship_method_id: "",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  amazon_prime: "0",
                  amz_promo: "",
                  sfp_alert: "0",
                  today:"2",
                  page: 1,
                  limit: 40
              };

          get_orders_list();
        };

        $scope.alltomorrow = function(data){
            $cookies.put('default_user_order_age','100');
            vm.default_user_order_age = $cookies.get('default_user_order_age');
            $cookies.put('premium_today_onsite','0');

            vm.query = {
                queryType:'array-count',
                search: "",
                product_id: "",
                store_id: "",
                financial_status_id: "4",
                fulfillment_status_id: "1,5,6",
                cancel_reason_id: "",
                order_status_id: "1",
                warehouse_id: "4",
                order_age: "105",
                order_age2:"90",
                picklist_id: "300",
                sales_channel:"",
                order_by: "alltoday",
                sort_order_by: "mp_ship_latest_by",
                ship_method_id: "",
                order_dir: "asc",
                order_sub_status_id: "1",
                amazon_prime: "0",
                amz_promo: "",
                sfp_alert: "0",
                today:"5",
                page: 1,
                limit: 40
            };

            get_orders_list();
        }

        $scope.alltolate = function(data) {

        	$cookies.put('default_user_order_age','99');
        	vm.default_user_order_age = $cookies.get('default_user_order_age');
        	$cookies.put('premium_today_onsite','0');

          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1,5,6",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  warehouse_id: "4",
                  order_age: "99",
                  order_age2:"90",
                  picklist_id: "300",
                  sales_channel:"",
                  order_by: "alltoday",
                  sort_order_by: "mp_ship_latest_by",
                  ship_method_id: "",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  amazon_prime: "0",
                  amz_promo: "",
                  sfp_alert: "0",
                  today:"4",
                  page: 1,
                  limit: 40
              }

          get_orders_list();
        }

        $scope.alltoshipframes = function(data) {
          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1,5,6",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  category_id: "991",
                  warehouse_id: "4",
                  order_age: "100",
                  order_age2:"90",
                  sales_channel:"",
                  order_by: "alltoday",
                  sort_order_by: "mp_ship_latest_by",
                  ship_method_id: "",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  alltoshipframes:"1",
                  amazon_prime: "0",
                  amz_promo: "",
                  sfp_alert: "0",
                  today:"4",
                  page: 1,
                  limit: 40
              };

          get_orders_list();
        };

        $scope.alltoship = function(data) {

        	$cookies.put('default_user_order_age','');
        	vm.default_user_order_age = $cookies.get('default_user_order_age');
        	$cookies.put('premium_today_onsite','0');

          vm.query = {
                  queryType:'array-count',
                  search: "",
                  product_id: "",
                  store_id: "",
                  financial_status_id: "4",
                  fulfillment_status_id: "1,5,6",
                  cancel_reason_id: "",
                  order_status_id: "1",
                  warehouse_id: "4",
                  order_age: "",
                  order_age2:"90",
                  sales_channel:"",
                  order_by: "alltoship",
                  sort_order_by: "mp_ship_latest_by",
                  ship_method_id: "",
                  order_dir: "asc",
                  order_sub_status_id: "1",
                  amazon_prime: "0",
                  amz_promo: "",
                  sfp_alert: "0",
                  today:"3",
                  page: 1,
                  limit: 40
              };

          get_orders_list();
        };

        activate();

        function activate() {
            var promises = [
                get_orders_list(),
                get_stores_v1(),
                get_order_status(),
                get_order_sub_status_v1(),
                get_fulfillment_status(),
                get_financial_status(),
                get_fulfillment_warehouses(),
                get_product_categories(),
                getProductSource(),
                get_order_picklists(),
                get_ship_methods()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    //  log('Activated Order List View');
                });
        }
        function get_ship_methods(){
          return datacontext.get_pp_shipping_methods().then(function (response) {
              $scope.ship_methods = response.data.data;
          });
        }

        function get_stores_v1() {
          return datacontext.get_stores_v1().then(function (httpResult) {
              vm.stores = httpResult.data.data;
          });
        }

        function get_order_status() {
          return datacontext.get_order_status().then(function (httpResult) {
              vm.order_status_list = httpResult.data.data;
          });
        }

        function get_order_sub_status_v1() {
          return datacontext.get_order_sub_status_v1().then(function (httpResult) {
              vm.order_sub_status_list = httpResult.data.data;
          });
        }

        function get_fulfillment_status() {
          return datacontext.get_fulfillment_status().then(function (httpResult) {
              vm.fulfillment_status_list = httpResult.data.data;
          });
        }

        function get_financial_status() {
          return datacontext.get_financial_status().then(function (httpResult) {
              vm.financial_status_list = httpResult.data.data;
          });
        }

        function get_fulfillment_warehouses() {
          return datacontext.get_warehouses().then(function (httpResult) {
              vm.fulfillment_warehouse_list = httpResult.data.data;
          });
        }
        function get_product_categories() {
            return datacontext.get_product_categories_v1({active_pid_count: 1}).then(function (httpResult) {
                $scope.product_categories = httpResult.data;

            });
        }
        function getProductSource() {
            return datacontext.get_product_source().then(function (httpResult) {
                vm.product_source = httpResult.data.data;
            });
        }
        function get_order_picklists() {
            return datacontext.get_order_picklists({order_age: vm.query.order_age2}).then(function (httpResult) {
                vm.order_picklists = httpResult.data.data;

            });
        }

        function get_orders_list() {
          //var sorting_value = vm.query.sort_order_by+':'+vm.query.order_dir;
          if(vm.query.sort_order_by === 'pickpack_slip_id'){
            vm.tableParams = new NgTableParams({
                count: vm.query.limit, // count per page
                sorting: {pickpack_slip_id: vm.query.order_dir}
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    vm.default_user_order_age = $cookies.get('default_user_order_age');
                    if(vm.default_user_order_age === '' || vm.default_user_order_age === 'undefined' || vm.default_user_order_age === undefined){
                        vm.default_user_order_age = 3;
                    }else{
                    	vm.query.order_age = vm.default_user_order_age;
                    }

                    if(vm.default_user_order_age === '100'){
                    	vm.query.today = '2';
                    }else if(vm.default_user_order_age === '99'){
                    	vm.query.today = '4';
                    }else if(vm.default_user_order_age === '3'){
                    	vm.query.order_age = '';
                    	vm.query.today = '3';
                    }

                    vm.premium_today_onsite = $cookies.get('premium_today_onsite');
                    if(vm.premium_today_onsite === '1'){
                    	vm.query.today = '';
                    	vm.query.todayonsite = '1';
                    	vm.query.ship_method_id = 'SecondDay';
                    	vm.query.warehouse_id = '6';
                    }

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
						            vm.query.sort_order_by = key;
                    }
                    // ajax request to api
                    return datacontext.get_orders_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        if(angular.isDefined(httpResult.data.SFP_ERROR)){
                            vm.SFP_ERROR = httpResult.data.SFP_ERROR;
                        }
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.order_picklistSummary =  httpResult.data.PICKLISTSUMMARY;
                        console.log(httpResult.data);
                        return httpResult.data.data;
                    });
                }
            });
          }else{//mp_ship_latest_by
            vm.tableParams = new NgTableParams({
                count: vm.query.limit, // count per page
                sorting: {mp_ship_latest_by: vm.query.order_dir}
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    vm.default_user_order_age = $cookies.get('default_user_order_age');
                    if(vm.default_user_order_age === '' || vm.default_user_order_age === 'undefined' || vm.default_user_order_age === undefined){
                        vm.default_user_order_age = 3;
                    }else{
                    	vm.query.order_age = vm.default_user_order_age;
                    }

                    if(vm.default_user_order_age === '100'){
                    	vm.query.today = '2';
                    }else if(vm.default_user_order_age === '99'){
                    	vm.query.today = '4';
                    }else if(vm.default_user_order_age === '3'){
                    	vm.query.order_age = '';
                    	vm.query.today = '3';
                    }

                    vm.premium_today_onsite = $cookies.get('premium_today_onsite');
                    if(vm.premium_today_onsite === '1'){
                    	vm.query.today = '';
                    	vm.query.todayonsite = '1';
                    	vm.query.ship_method_id = 'SecondDay';
                    	vm.query.warehouse_id = '6';
                    }

                    console.log(vm.default_user_order_age);
                    console.log(vm.query);

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
						            vm.query.sort_order_by = key;
                    }

                    // ajax request to api
                    return datacontext.get_orders_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        if(angular.isDefined(httpResult.data.SFP_ERROR)){
                            vm.SFP_ERROR = httpResult.data.SFP_ERROR;
                        }
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.order_picklistSummary =  httpResult.data.PICKLISTSUMMARY;
                        return httpResult.data.data;
                    });
                }
            });
          }

        }

         $scope.importAmazonOrder = function () {
           $scope.import_order = '';
            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/import_amazon_order.html',
                controller: 'importAmazonOrderctrl',
                windowClass: 'small',
                resolve: {
                  mp_order: function () {
                      return $scope.import_order;
                  }
                }
            }).result.then(function (result) {

            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
        $scope.resetImportOrder = function (){
          $scope.data = {order_id : '', store_id : '', src : ''};
        };
        if(angular.isDefined($routeParams.import_order)){
          $scope.import_order = $routeParams.import_order;
          var modalInstance = $modal.open({
              templateUrl: '/app/orders/partials/import_amazon_order.html',
              controller: 'importAmazonOrderctrl',
              windowClass: 'small',
              resolve: {
                mp_order: function () {
                    return $scope.import_order;
                }
              }
          }).result.then(function (result) {

          });

          vm.cancel = function () {
              modalInstance.dismiss('cancel');
          };
        }

        $scope.importWalmartOrder = function () {

           var modalInstance = $modal.open({
               templateUrl: '/app/orders/partials/import_walmart_order.html',
               controller: 'importWalmartOrderctrl',
               windowClass: 'small',
               resolve: {
               }
           }).result.then(function (result) {

           });

           vm.cancel = function () {
               modalInstance.dismiss('cancel');
           };
       };

       $scope.createManualOrder = function() {

          var modalInstance = $modal.open({
            templateUrl: 'app/orders/partials/create_manual_order.html',
            controller: 'createManualOrderctrl',
            windowClass: 'small',
            resolve: {

            }
          }).result.then(function (result) {

          });

          vm.cancel = function(){
            modalInstance.dismiss('cancel');
          };
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'orderDetailCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$window', '$modal', '$log', '$timeout', '$cookies','ngDialog', orderDetailCtrl]);

    function orderDetailCtrl(common, datacontext, $scope, $routeParams, $window, $modal, $log, $timeout, $cookies, ngDialog) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logWarning = getLogFn(controllerId, 'logWarning');
        var logError = getLogFn(controllerId, 'logError');
        var log_success = getLogFn(controllerId,'success');

        var vm = this;
        var str = $routeParams.oid;
        vm.order_id = "";
        var matches = str.match(/\d+/g);
        vm.user_role_id = 0;
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
        }
        for(var i = 0; i < matches.length; i++){
        	vm.order_id = vm.order_id + matches[i];
        }
        vm.ship_address = [];
        vm.bill_address = [];
        vm.order = [];
        vm.order_items = [];
        vm.financial_status = [];
        vm.fulfillment_status = [];
        vm.title = 'Orders Detail View';
        vm.order_status_update = '';
        vm.label_host = '//s3.amazonaws.com/gco_bucket/shiplabels/';
        vm.manual_fulfillment_update = '';
        vm.updated = 0;
        vm.orderDateCheck = 0;

        // setting for audit log
        $scope.audit_link_id = vm.order_id;
        $scope.audit_type_id = 2;

        activate();

        function activate() {
            var promises = [
                get_orders(),
                getOrderItems(),
                get_financial_status(),
                get_reship_reasons(),
                get_fulfillment_status(),
                get_order_packages_status()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Order Detail');
                });
        }

        function get_orders() {

            var payload = {
                queryType:"struct",
                order_id: vm.order_id
            };
            return datacontext.get_orders(payload).then(function (httpResult) {
                vm.order = httpResult.data.data;

                if (Number(vm.order.bill_address_id) > 0) {
                    datacontext.getCustomerAddress({address_id: vm.order.bill_address_id}).success(function (httpResult) {
                        if (httpResult.success === true) {
                            vm.bill_address = httpResult.data;
                            vm.bill_address[0].order_id = vm.order_id;
                        } else {
                            //$scope.errors.push(result.error);
                            logError('Error returning bill address');
                        }
                    });
                }

                if(vm.order.store_id == 8){
                    var start = moment();
                    var end = moment(vm.order.mp_ship_by);
                    var dif = end.diff(start,'days');
                }else{
                    var start = moment();
                    var end = moment(vm.order.mp_ship_latest_by);
                    var dif = end.diff(start,'days');
                }

                if(dif < 1){
                    vm.orderDateCheck = 1;
                }

                datacontext.getCustomerAddress({address_id: vm.order.ship_address_id}).success(function (httpResult) {
                    if (httpResult.success === true) {
                        vm.ship_address = httpResult.data;
                        vm.ship_address[0].order_id = vm.order_id;
                    } else {
                        //$scope.errors.push(result.error);
                        logError('Error returning ship address');
                    }
                });

            });
        }

        function getOrderItems() {

            return datacontext.getOrderItems({order_id: vm.order_id}).then(function (httpResult) {
              if(angular.isDefined(httpResult.data.COMBINED_ORDERS)){
                vm.combined_custmer_orders = httpResult.data.COMBINED_ORDERS;
                console.log(vm.combined_custmer_orders);
              }
                vm.order_items = httpResult.data.data;
                if(angular.isDefined($routeParams.print)){
                  setTimeout(function () {
                    $('.print_fnsku_beta').click();
                  }, 1000);
                  setTimeout(function () {
                    $('.ship_label_jquery').click();
                  }, 1000);

                }
            });
        }

        function get_financial_status() {
            return datacontext.get_financial_status().then(function (httpResult) {
                vm.financial_status = httpResult.data.data;
            });
        }

        function get_fulfillment_status() {
            return datacontext.get_fulfillment_status().then(function (httpResult) {
                vm.fulfillment_status = httpResult.data.data;
            });
        }

        function get_order_packages_status() {
          return datacontext.get_order_packages_status().then(function (httpResult) {
              vm.order_packages_status = httpResult.data.data;
          });
        }

        function get_reship_reasons() {
            return datacontext.get_reship_reasons().then(function(httpResult) {
                vm.get_reship_reasons = httpResult.data.data;
            });
        }

        $scope.open_fulfillment_modal = function () {
            // merge order item w/order items
            $scope.fulfillment_order = vm.order;
            $scope.fulfillment_order.items = vm.order_items;

            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/fulfillment_modal.html',
                controller: 'fulfillmentModalCtrl',
                resolve: {
                    fulfillment_order: function () {
                        return $scope.fulfillment_order;
                    }
                }
            }).result.then(function (result) {
                $scope.tracking_number = result;
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.editFulfillmentStatusModel = function () {

            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/fulfillment_status_modal.html',
                controller: 'fulfillmentStatusModalCtrl',
                windowClass: 'small',
                resolve: {
                    fulfillmentStatus: function () {
                        return $scope.vm.order;
                    }
                }
            }).result.then(function (result) {
                get_orders();
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
        $scope.editfinancialStatusModel = function () {

            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/financial_status_modal.html',
                controller: 'financialStatusModalCtrl',
                windowClass: 'small',
                resolve: {
                    financialStatus: function () {
                        return $scope.vm.order;
                    }
                }
            }).result.then(function (result) {
                get_orders();
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
        $scope.editShipByDateModel = function () {

            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/ship_by_date_modal.html',
                controller: 'shipByDateModalCtrl',
                windowClass: 'small',
                resolve: {
                    shipByDate: function () {
                        return $scope.vm.order;
                    }
                }
            }).result.then(function (result) {
                get_orders();
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

         $scope.cancelOrder = function () {

            $scope.cancel_order = vm.order;
            $scope.cancel_order.items = vm.order_items;

            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/cancel_order.html',
                controller: 'cancelOrderctrl',
                windowClass: 'small',
                resolve: {
                    cancelOrder: function () {
                        return $scope.cancel_order;
                    }
                }
            }).result.then(function (result) {
                   $timeout(function () {
                         activate();
                  }, 4000);
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.open_hold_modal = function () {
            // merge order item w/order items
            $scope.hold_order = vm.order;

            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/hold_modal.html',
                controller: 'orderholdModalCtrl',
                resolve: {
                    hold_order: function () {
                        return $scope.hold_order;
                    }
                }
            }).result.then(function (result) {
                // Update Order status id and order note
                get_orders();
                $scope.$broadcast('refreshAuditLog', 'refresh');

            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

	$scope.open_cancel_modal = function () {
            // merge order item w/order items
            $scope.cancel_order = vm.order;
            $scope.cancel_order.order_note_new = "";
            vm.query = {
	                order_note:'',
	                order_id: $scope.cancel_order.order_id
	            };
            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/cancel_modal.html',
                controller: 'ordercancelModalCtrl',
                resolve: {
                	cancel_order: function () {
                        return $scope.cancel_order;
                    }
                }
            }).result.then(function (result) {
                // Update Order status id and order note
                get_orders();
                $scope.$broadcast('refreshAuditLog', 'refresh');

            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
        $scope.open_refund_modal = function () {
            // merge order item w/order items
            $scope.refund_order = vm.order;
            var date = new Date();
            //$scope.date = $scope.date.format('MM/DD/YY');
            $scope.FromDate = ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' + date.getFullYear();
            $scope.refund_order.order_note = $scope.FromDate + "- Order Refunded - " + $scope.refund_order.order_note;
            $scope.refund_order.items = vm.order_items;
            //console.log($scope.refund_order);
            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/refund_modal.html',
                controller: 'refundModalCtrl',
                resolve: {
                    refund_order: function () {
                        return $scope.refund_order;
                    }
                }
            }).result.then(function (result) {
                get_orders();
                $scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.print_fnsku = function (order_id,fnsku,spid) {
          $scope.order_id = order_id;
          $scope.fnsku = fnsku;
          $scope.spid = spid;

          datacontext.getOrderPrintFullFnsku({order_id:order_id, fnsku:fnsku, spid:spid}).then(function(httpResult) {
              $scope.ship_details = httpResult.data.data;
              if(isNaN($scope.fnsku)){
                $scope.fnsku_label = "FNSKU: ";
                //console.log("string");
              }else{
                //console.log("number");
                $scope.fnsku_label = "**** SKU: ";
              }
              if(isNaN($scope.fnsku)){
                $scope.fnsku_label = "FNSKU: ";
                $scope.fnsku =  $scope.fnsku;
                $scope.fnsku_v1 =  $scope.fnsku +' / ' + $scope.spid;
                //console.log("string");
              }else{
                //console.log("number");
                $scope.fnsku_label = "**** SKU:";
                $scope.fnsku =  'BB01-'+$scope.spid;
                $scope.fnsku_v1 =  'BB01-'+$scope.spid;
              }
              //console.log($scope.fnsku);
              //console.log(fnsku);
              $scope.first_name = $scope.ship_details[0].first_name;
              $scope.last_name = $scope.ship_details[0].last_name;
              $scope.address_1 = $scope.ship_details[0].address_1;
              $scope.address_2 = $scope.ship_details[0].address_2;
              //$scope.address_3 = $scope.ship_details[0].address_3;
              $scope.city = $scope.ship_details[0].city;
              $scope.province_code = $scope.ship_details[0].province_code;
              $scope.ship_courier  = $scope.ship_details[0].ship_courier ;
              $scope.ship_method  = $scope.ship_details[0].ship_method ;
              $scope.ship_service_level  = $scope.ship_details[0].ship_service_level ;
              $scope.order_id  = $scope.ship_details[0].order_id ;
              $scope.product_title = $scope.ship_details[0].product_title;
              $scope.category_name = $scope.ship_details[0].category_name;
              $scope.width_height = $scope.ship_details[0].width_height;
              $scope.reprint_date = new Date();
              //$scope.order_package_id  = $scope.ship_details[0].order_package_id ;
              var ship_method_id = 4;
              $scope.ship_method_id = ship_method_id;
              $scope.marketplace_order_id = $scope.ship_details[0].marketplace_order_id;
              $scope.warehouse_id =  $scope.ship_details[0].warehouse_id;
              $scope.pickpack_slip_id = $scope.ship_details[0].pickpack_slip_id;
              // create barcode
              // datacontext.createBarCode({label: order_id}).then(function() {
              // 	$scope.random = Math.floor((Math.random()*6)+1);
              // });
              datacontext.createBarCode({label: $scope.fnsku}).then(function() {
                $scope.fnskurandom = Math.floor((Math.random()*6)+1);
              });

              datacontext.createBarCode({label: $scope.marketplace_order_id}).then(function() {
                  $scope.random = Math.floor((Math.random()*6)+1);
              });
              ngDialog.open({
                  template: 'app/orderpackages/ship_label.html',
                  scope: $scope
              });
          });
          ngDialog.open({
              template: 'app/orderpackages/ship_label.html',
              scope: $scope
          });
        };
        $scope.print_fnsku_beta = function (order_id,fnsku,spid) {
          $scope.order_id = order_id;
          $scope.fnsku = fnsku;
          $scope.spid = spid;

          datacontext.getOrderPrintFullFnsku({order_id:order_id, fnsku:fnsku, spid:spid}).then(function(httpResult) {
              $scope.ship_details = httpResult.data.data;

              //console.log($scope.ship_details);
            //  console.log($scope.ship_details[0].address_1);
              //console.log($scope.fnsku.length);
            //console.log("here"+fnsku.length);

              if(isNaN($scope.fnsku)){
                $scope.fnsku_label = "FNSKU: ";
                $scope.fnsku =  $scope.fnsku;
                $scope.fnsku_v1 =  $scope.fnsku +' / ' + $scope.spid;
                //console.log("string");
              }else{
                //console.log("number");
                $scope.fnsku_label = "**** SKU:";
                $scope.fnsku =  'BB01-'+$scope.spid;
                $scope.fnsku_v1 =  'BB01-'+$scope.spid;
              }
              /*var spids = [861328,861331,873380,874617,874723,875132,875136,875138,875140,876330,876341,876466,882386,883087,883300,885698,886561,886907,889037,889039];
              $scope.spid_ex = spids.indexOf($scope.spid);
              if($scope.spid_ex > 0){
                $scope.spids_ex = '!!!';
              }else{
                $scope.spids_ex = '';
              }*/
              $scope.spids_ex = '';
              $scope.sort_title = $scope.ship_details[0].sort_title;
              console.log("$scope.spids_ex"+$scope.spids_ex);
              $scope.user_name = $cookies.get('user_name');
              //console.log($scope.fnsku);
              //console.log(fnsku);
              $scope.first_name = $scope.ship_details[0].first_name;
              $scope.last_name = $scope.ship_details[0].last_name;
              $scope.address_1 = $scope.ship_details[0].address_1;
              $scope.address_2 = $scope.ship_details[0].address_2;
              //$scope.address_3 = $scope.ship_details[0].address_3;
              $scope.city = $scope.ship_details[0].city;
              $scope.province_code = $scope.ship_details[0].province_code;
              $scope.ship_courier  = $scope.ship_details[0].ship_courier ;
              $scope.ship_method  = $scope.ship_details[0].ship_method ;
              $scope.ship_service_level  = $scope.ship_details[0].ship_service_level ;
              $scope.order_id  = $scope.ship_details[0].order_id ;
              $scope.product_title = $scope.ship_details[0].product_title;
              $scope.category_name = $scope.ship_details[0].category_name;
              $scope.width_height = $scope.ship_details[0].width_height;
              $scope.reprint_date = new Date();
              $scope.mp_ship_latest_by = $scope.ship_details[0].mp_ship_latest_by;
              //$scope.order_package_id  = $scope.ship_details[0].order_package_id ;
              var ship_method_id = 4;
              $scope.ship_method_id = ship_method_id;
              $scope.marketplace_order_id = $scope.ship_details[0].marketplace_order_id;
              $scope.warehouse_id =  $scope.ship_details[0].warehouse_id;
              $scope.onsite_pkg_number =  $scope.ship_details[0].onsite_pkg_number;
              $scope.pickpack_slip_id = $scope.ship_details[0].pickpack_slip_id;
              // create barcode
              // datacontext.createBarCode({label: order_id}).then(function() {
              // 	$scope.random = Math.floor((Math.random()*6)+1);
              // });
              // datacontext.createBarCode({label: $scope.fnsku}).then(function() {
              //   $scope.fnskurandom = Math.floor((Math.random()*6)+1);
              // });

              // datacontext.createBarCode({label: $scope.marketplace_order_id}).then(function() {
              //     $scope.random = Math.floor((Math.random()*6)+1);
              // });
              ngDialog.open({
                  template: 'app/orderpackages/ship_label_beta.html',
                  scope: $scope
              });
              //if(order_id === 2134684){
                setTimeout(function () {
                  $('.ship_label_jquery').click();
                }, 1000);
              //}


          });
          // ngDialog.open({
          //     template: 'app/orderpackages/ship_label_beta.html',
          //     scope: $scope,
          //     onOpenCallback: function(value) {
          //       console.log("print1");
          //     }
          // });

        };

        $scope.redirectToFnskuPage = function(order_id, fnsku, spid) {
            var url = 'https://ace.gothamcityonline.com/reports/pid_barcode_label.cfm?SPID=' + spid;

            // Redirect to the new page
            //window.location.href = url;
            window.open(url, '_blank');
        };

        $scope.open_reship_modal = function () {
            // merge order item w/order items
            $scope.reship = vm.order;
            $scope.reship.items = vm.order_items;
            $scope.reship.items.reship_spid = '';
            $scope.reship.items.ship_by_date = '1';
            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/reship_modal.html',
                controller: 'reshipModalCtrl',
                resolve: {
                    reship: function () {
                        return $scope.reship;
                    }
                }
            }).result.then(function (result) {
                get_orders();
                $scope.$broadcast('refreshOrderPackagesCtrl', 'refresh');
                $scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.open_add_item = function () {
        	$scope.additem = vm.order;
        	$scope.additem.items = vm.order_items;
        	$scope.additem.items.add_item_spid = '';
        	$scope.additem.items.ship_by_date = '1';
        	var modalInstance = $modal.open({
        		templateUrl: '/app/orders/partials/add_order_item_modal.html',
        		controller: 'addorderitemModalCtrl',
        		resolve: {
        			additem: function () {
        				return $scope.additem;
        			}
        		}
        	}).result.then(function (result) {
        		get_orders();
        		$scope.$broadcast('refreshOrderPackagesCtrl', 'refresh');
        		$scope.$broadcast('refreshAuditLog', 'refresh');
        	});

        	vm.cancel = function () {
        		modalInstance.dismiss('cancel');
        	}
        };

        $scope.open_split_modal = function(){

        	console.log(vm.order);
           
            $scope.reship = vm.order;
            $scope.reship.items = vm.order_items;
            $scope.reship.items.reship_spid = '';
            $scope.reship.items.ship_by_date = '1';
            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/split_modal.html?order_id=vm.order',
                controller: 'splitModalCtrl',
                resolve: {
                    reship: function () {
                        return $scope.reship;
                    }
                }
            }).result.then(function (result) {
                get_orders();
                $scope.$broadcast('refreshOrderPackagesCtrl', 'refresh');
                $scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        }

        $scope.audit_print = function (data) {

            var print_audit = {
                audit_subtype_id: 14,
                link_id: data.order_id,
                data: '{package_id:' + data.order_package_id + '}'
            };

            return datacontext.create_audit_log(print_audit).then(function (httpResult) {
                get_orders();
                $scope.$broadcast('refreshAuditLog', 'refresh');
            });
        };

        $scope.open_edit_address_modal = function (data) {
            // merge order item w/order items
            $scope.edit_address = data;

            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/edit_address_modal.html',
                controller: 'editAddressModalCtrl',
                resolve: {
                    edit_address: function () {
                        return $scope.edit_address;
                    }
                }
            }).result.then(function (result) {
                $scope.tracking_number = result;
                get_orders();
                $scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.open_edit_ship_service = function (data) {
            // merge order item w/order items
            $scope.edit_ship_service = data;
            //console.log($scope.edit_ship_service);
            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/edit_ship_service.html',
                controller: 'editShipServiceModalCtrl',
                resolve: {
                	edit_ship_service: function () {
                        return $scope.edit_ship_service;
                    }
                }
            }).result.then(function (result) {
                //$scope.tracking_number = result;
                get_orders();
                $scope.$broadcast('refreshAuditLog', 'refresh');
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        // Save Order Note
        // todo: create notes that are more timeline based
        $scope.updateOrderNotes = function (data) {
            vm.updated = 1;

            var payload = {
                order_id: data.order_id,
                order_note: data.order_note,
                packing_note: data.packing_note
            };

            return datacontext.updateOrder(payload).then(function (httpResult) {
                //console.log(httpResult);
                $scope.$broadcast('refreshAuditLog', 'refresh');
                log_success('Updated Order Notes');
                vm.updated = 0;
            });
        };

        $scope.open_change_order_status_modal = function () {
            // combine
            vm.order_status_update = 'here';
            var modalInstance = $modal.open({
                templateUrl: '/app/orders/partials/order_status_modal.html',
                controller: 'orderArchiveCtrl',
                windowClass: 'small',
                resolve: {
                    order: function () {
                        return vm.order;
                        get_orders();
                        $scope.$broadcast('refreshAuditLog', 'refresh');
                    }
                }
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };

            modalInstance.result.then(function (order_status_update) {
                vm.order_status_update = order_status_update;
                get_orders();
                $scope.$broadcast('refreshAuditLog', 'refresh');

            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };
        $scope.total = 0;
        $scope.setTotals = function(item){
            if (item){
                //$scope.total = $scope.total +(item.qty_ordered * item.price_sold);

                var multiQty = item.multi_qty || 1;
                if(multiQty > 1){
                  $scope.total += (item.to_ship_qty_new / multiQty) * item.price_sold;  
                } else {
                  $scope.total += (item.qty_ordered / multiQty) * item.price_sold;
                }
                
            }
        }

    }
})();

(function () {
    'use strict';
    var controllerId = 'openItemsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$position', '$filter', '$location', 'ngTableParams', openItemsCtrl]);

    function openItemsCtrl(common, datacontext, $scope, $position, $filter, $location, ngTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.products = [];
        vm.totalPages = 0;
        vm.productCount = 0;
        vm.currentPage = 4;

        //default criteria that will be sent to the server
        vm.filterCriteria = {
            pageNumber: 1,
            sortDir: 'asc',
            sortedBy: 'id'
        };

        vm.customFilter = function (queryColumn, query) {
            if (queryColumn === '') {
                return "''";
            } else {
                return {queryColumn: query};
            }
        };

        activate();

        function activate() {
            var promises = [get_open_items(), get_pickpack_status()];
            common.activateController(promises, controllerId)
                .then(function () {
                });
        }

        function get_open_items() {
            return datacontext.get_open_items(vm.filterCriteria).then(function (httpResult) {
                var products = httpResult.data.data;

                $scope.$watch("filter.$", function () {
                    $scope.tableParams.reload();
                });

                $scope.$watch("pickpack_status.$", function () {
                    $scope.tableParams.reload();
                });

                $scope.$watch("stock_status.$", function () {
                    $scope.tableParams.reload();
                });

                $scope.tableParams = new ngTableParams(
                    angular.extend(
                        {
                            page: 1, // show first page
                            count: 100, // count per page
                            sorting: {
                                ordered_on: 'asc'  // initial sorting
                            },
                            filter: {}
                        },
                        $location.search()),
                    {
                        total: products.length, // length of data
                        getData: function ($defer, params) {
                            var QueryData = $filter('filter')(products, $scope.filter);
                            var pickpack_filter = $filter('filter')(QueryData, $scope.pickpack_status);
                            var stock_status_filter = $filter('filter')(pickpack_filter, $scope.stock_status);
                            var filteredData = params.filter() ?
                                $filter('filter')(stock_status_filter, params.filter()) :
                                data;
                            var orderedData = params.sorting() ?
                                $filter('orderBy')(filteredData, params.orderBy()) :
                                filteredData;

                            params.total(orderedData.length); // set total for recalc pagination
                            $scope.resultcount = orderedData.length;

                            $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                        },
                        $scope: $scope
                    });
            });
        }

        function get_pickpack_status() {
            return datacontext.get_pickpack_status().then(function (httpResult) {
                vm.get_pickpack_status = httpResult.data.data;
            });
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'fulfillmentModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'fulfillment_order', fulfillmentModalCtrl]);

    function fulfillmentModalCtrl(common, datacontext, $scope, $modalInstance, fulfillment_order) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.fulfillment_order = fulfillment_order;

        // Ship Methods
        datacontext.get_ship_methods().then(function (response) {
            $scope.ship_methods = response.data.data;
        });

        $scope.ok = function () {
            // set variables
            var formData = {};
            formData.order_id = $scope.fulfillment_order.order_id;

            // get pickslip id
            formData.pickpack_slip_id = $scope.fulfillment_order.items[0].pickpack_slip_id;
            formData.ship_method_id = $scope.fulfillment_order.ship_method_id;
            formData.tracking_code = $scope.fulfillment_order.tracking_code;
            formData.bypass_marketplace_update = $scope.fulfillment_order.bypass_marketplace_update;

            // create new order ship tracking entry
            return datacontext.createOrderPackage(formData).then(function (httpResult) {
                var order_package_id = httpResult.data;
                // loop items flag for update

                angular.forEach($scope.fulfillment_order.items, function (item) {
                    // set order item variables
                    var formItemData = {};
                    formItemData.order_item_id = item.order_item_id;
                    formItemData.qty_shipped = item.qty_shipped;
                    formItemData.order_package_id = order_package_id;
                    // Update Order items
                    return datacontext.updateOrderItem(formItemData).then(function (response) {
                        // Refresh Order item data

                    });
                }, log);

                var audit_data = {
                    ship_method_id: $scope.fulfillment_order.ship_method_id,
                    tracking_code: $scope.fulfillment_order.tracking_code
                };
                var audit_info = {
                    audit_subtype_id: 10,
                    link_id: $scope.fulfillment_order.order_id,
                    data: audit_data
                };

                datacontext.create_audit_log(audit_info).then(function (response) {

                    // Refresh Order item data
                });
                $modalInstance.close(order_package_id);
            });

            // add new order ship tracking entry to order item

            $modalInstance.close($scope.fulfill);
            //return datacontext.update_order_status(order[0].order_id, 2).then(function(httpResult) {
            //    $modalInstance.close($scope.fulfillment_order);
            //});
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'orderholdModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'hold_order', orderholdModalCtrl]);

    function orderholdModalCtrl(common, datacontext, $scope, $modalInstance, hold_order) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.hold_order = hold_order;

        // Ship Methods
        datacontext.get_ship_methods().then(function (response) {
            $scope.ship_methods = response.data.data;

        });

        $scope.ok = function (new_order_status_id) {
            // set variables
            var formData = {
                order_id: $scope.hold_order.order_id,
                order_status_id: new_order_status_id,
                order_note: $scope.hold_order.order_note
            };

            // update order status / set order note
            return datacontext.updateOrder(formData).then(function (httpResult) {
                $modalInstance.close(formData);
            });

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'ordercancelModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'cancel_order', ordercancelModalCtrl]);

    function ordercancelModalCtrl(common, datacontext, $scope, $modalInstance, cancel_order) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        // Pushes input to scope
        $scope.cancel_order = cancel_order;


        // Ship Methods
        datacontext.get_ship_methods().then(function (response) {
            $scope.ship_methods = response.data.data;

        });

        $scope.ok = function () {
            // set variables
            var formData = {
                order_id: $scope.cancel_order.order_id,
                order_note: $scope.cancel_order.order_note
            };


            console.log(formData);

            // update order status / set order note
            return datacontext.cancelCompleteOrder(formData).then(function (httpResult) {
                $modalInstance.close(formData);
            });

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'refundModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'refund_order', refundModalCtrl]);

    function refundModalCtrl(common, datacontext, $scope, $modalInstance, refund_order) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        // Pushes input to scope
        $scope.refund_order = refund_order;

        // Ship Methods
        datacontext.get_cancel_reasons().then(function (response) {
            $scope.order_cancel_reasons = response.data.data;
        });

        $scope.ok = function () {

            // param full refund
            var financial_status_id = 6;

            // loop items flag for update
            var total_items = $scope.refund_order.items.length;
            var item_count = 0;
            if($scope.refund_order.cancel_reason_id > 0){
              angular.forEach($scope.refund_order.items, function (item) {
                console.log($scope);
                  // set order item variables
                  var formItemData = {};
                  formItemData.order_item_id = item.order_item_id;
                  formItemData.qty_refunded = item.qty_refunded;
                  formItemData.jet_order_id = $scope.refund_order.jet_def_order_id;
                  formItemData.alt_refund_id = $scope.refund_order.order_id;
                  formItemData.order_item_id1 = item.marketplace_order_item_id;
                  formItemData.refund_reason = $scope.refund_order.jet_cancel_reason;
                  formItemData.notes = $scope.refund_order.refund_note;
                  formItemData.principal = eval(item.price_sold * item.qty_refunded);
                  formItemData.tax = item.tax;
                  formItemData.shipping_cost = item.shipping_cost;
                  formItemData.shipping_tax = item.shipping_tax;

                  if ( (Number(item.qty_refunded) > 0) && item.store_id === 6 ) {
                      updateOrderjet(formItemData);
                  }

                  if (Number(item.qty_refunded) < Number(item.qty_ordered)) {
                      // set partial refund
                      financial_status_id = 5;
                  }
                  // Update Order items
                  datacontext.updateOrderItem(formItemData).then(function (response) {
                      item_count ++;
                      if (total_items === item_count) {
                          updateOrder();
                      }
                  });
              });

              // todo: fix lame promise to make sure updateOrderItem is done updating before running

              var updateOrder = function () {
                  // set variables
                  var payload = {
                      order_id: $scope.refund_order.order_id,
                      financial_status_id: financial_status_id,
                      cancel_reason_id: $scope.refund_order.cancel_reason_id,
                      notes: $scope.refund_order.order_note
                  };

                  // update order status
                  datacontext.update_order_financial_status(payload).then(function (httpResult) {
                      var audit_data = {
                          cancel_reason_id: $scope.refund_order.cancel_reason_id
                      };

                      var audit_info = {
                          audit_subtype_id: 12,
                          link_id: $scope.refund_order.order_id,
                          data: angular.toJson(audit_data)
                      };

                      datacontext.create_audit_log(audit_info).then(function (httpResult) {
                          // Refresh Order item data
                          $modalInstance.close('update');
                      });
                  });

              }


              function updateOrderjet(formItemData) {

                  // update order status
                  datacontext.refund_order_item_jet(formItemData).then(function (httpResult) {

                      if(httpResult.data.data == 1){
                          log_success('Refund Successfully updated in Jet');
                      }else{
                          log_error('Refund updating in Jet Failed');
                      }

                  });

              }
            }else{
              log_error('Please select Cancel / Refund Reason');
              $scope.error_message = "Please select Cancel / Refund Reason";
            }

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();


(function () {
    'use strict';
    var controllerId = 'reshipModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'reship', reshipModalCtrl]);

    function reshipModalCtrl(common, datacontext, $scope, $modalInstance, reship) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var error = getLogFn(controllerId,'error');

        // check if items to reship
        var has_reship_items = 0;
        var has_reship_new_items = 0;
        var has_back_stock = 0;
        // Pushes input to scope
        $scope.reship = reship;
        $scope.picklists_id = 0;
        $scope.ship_by_date = 1;
        $scope.submitted = false;

        // Ship Methods
        datacontext.get_ship_methods().then(function (response) {
            $scope.ship_methods = response.data.data;
        });

        //get previous pick list
        datacontext.get_picklist_type_id({order_id:reship.order_id}).then(function (response) {
        	$scope.reship.picklists_id = response.data.data;
        });


        //picklsit types
        datacontext.get_picklists().then(function (response) {
            $scope.picklists = response.data.data;
        });

        // ReShip reasons
        datacontext.get_reship_reasons().then(function (response) {
            $scope.reship_reasons = response.data.data;
        });



        $scope.ok = function () {
          $scope.submitted = true;
        	console.log($scope.reship);
            angular.forEach($scope.reship.items, function (item) {
              console.log("item");
              console.log(item);
                if (item.qty_reship > 0) {
                    has_reship_items = 1;
                    has_back_stock = 0;
                    if(item.reship_reason_id === 0){
                    	has_reship_items = 0;
                		error('Please select reship reason.');
                	}else if(item.reship_reason_id === 6){
                		has_back_stock = 1;
                	}
                }
                if (item.qty_new_shipped > 0) {
                    has_reship_new_items = 1;
                    has_back_stock = 0;
                    if(item.reship_reason_id_new === 0){
                    	has_reship_items = 0;
                		error('Please select "Add new item" reason.');
                	}else if(item.reship_reason_id_new === 6){
                		has_back_stock = 1;
                	}
                }
                if(angular.isDefined(item.reship_spid1)){
                  reship.reship_spid = item.reship_spid1;
                }

            });
            console.log("has_reship_items:"+has_reship_items);
            //making these common
            // set package header info
            var package_header = {
                order_id: reship.order_id,
                order_package_type_id: 2,
                ship_method_id: reship.ship_method_id,
                reship_spid: reship.reship_spid,
                pickpack_type_id:reship.picklists_id,
                ship_by_date: reship.ship_by_date,
                reship: 1
            };

            console.log("package_header:");
            console.log(package_header);
            if(reship.ship_by_date === ""){
              reship.ship_by_date = 1;
            }
            // update order status
            if(has_back_stock ===1){
            	var orderStatus = {
	                    order_id: reship.order_id,
	                    fulfillment_status_id: 1,
	                    order_status_id: 1,
	                    order_sub_status_id: 3,
                      mp_ship_latest_by: reship.ship_by_date
	                };
            }else{
            	var orderStatus = {
	                    order_id: reship.order_id,
	                    fulfillment_status_id: 1,
	                    order_status_id: 1,
	                    order_sub_status_id: 2,
                      mp_ship_latest_by: reship.ship_by_date
	                };
            }

            if(has_reship_new_items > 0){
            	 // set package header info
                var package_header = {
                    order_id: reship.order_id,
                    order_package_type_id: 2,
                    ship_method_id: reship.ship_method_id,
                    reship_spid: reship.reship_spid,
                    pickpack_type_id:reship.picklists_id,
                    ship_by_date: reship.ship_by_date,
                    reship: 1
                };
            }
            if (has_reship_items > 0 || has_reship_new_items > 0) {
            	return datacontext.updateOrder(orderStatus).then(function (httpResult) {
                    //console.log('order status', httpResult);

                    // create package
                    return datacontext.createOrderPackage(package_header).then(function (httpResult) {
                        // Refresh Order item data
                        var order_package_id = httpResult.data;

                        var audit_data = {
                            cancel_reason_id: $scope.reship.cancel_reason_id
                        };

                        var audit_info = {
                            audit_subtype_id: 12,
                            link_id: $scope.reship.order_id,
                            data: angular.toJson(audit_data)
                        };

                        datacontext.create_audit_log(audit_info).then(function (httpResult) {});
                        console.log($scope.reship.items);
                        //loop items flag for update reship exchange
                        angular.forEach($scope.reship.items, function (item) {
                            // set order item variables
                            if (item.qty_reship > 0) {
                            	console.log("reship_spid");
                                console.log(item);

                            	if(reship.reship_spid > 0){
                            		var item = {
    	                                    order_package_id: order_package_id,
    	                                    order_item_id: item.order_item_id,
    	                                    store_product_id: item.store_product_id,
    	                                    product_id: reship.reship_spid,
    	                                    to_ship_qty: item.qty_reship,
    	                                    reship_reason_id: item.reship_reason_id,
    	                                    store_id: $scope.reship.store_id
    	                                };
                            	}else{
                            		var item = {
    	                                    order_package_id: order_package_id,
    	                                    order_item_id: item.order_item_id,
    	                                    store_product_id: item.store_product_id,
    	                                    product_id: item.product_id,
    	                                    to_ship_qty: item.qty_reship,
    	                                    reship_reason_id: item.reship_reason_id
    	                                };
                            	}
                            	console.log(item);
                                // add items to package
                                return datacontext.createOrderPackageItem(item).then(function (httpResult) {});
                            }
                        });
                        //loop items flag for update new reship item
                        angular.forEach($scope.reship.items, function (item) {
                            // set order item variables
                            if (item.qty_new_reship > 0) {
                            	console.log("qty_new_reship:"+item);

                            	if(item.reship_new_spid > 0){
                            		var item = {
    	                                    order_package_id: order_package_id,
    	                                    order_item_id: item.order_item_id,
    	                                    store_product_id: item.store_product_id,
    	                                    product_id: item.reship_new_spid,
    	                                    to_ship_qty: item.qty_new_reship,
    	                                    qty_ordered: item.qty_new_ordered,
    	                                    reship_reason_id: item.reship_reason_id_new,
    	                                    store_id: $scope.reship.store_id,
    	                                    order_id: $scope.reship.order_id
    	                                };
                            	}
                            	console.log(item);
                                // add items to package
                                return datacontext.createOrderPackageItem(item).then(function (httpResult) {});
                            }
                        });

                        // set package type
                        $modalInstance.close();
                    });
                });
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
	'use strict';
	var controllerId = 'addorderitemModalCtrl';
	angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'additem', addorderitemModalCtrl]);

	function addorderitemModalCtrl(common, datacontext, $scope, $modalInstance, additem) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var error = getLogFn(controllerId, 'error');

		// add items
		var has_add_items = 0;
		var has_add_new_items = 0;
		var has_back_stock = 0;

		//Pushes input to scope
		$scope.additem = additem;
		$scope.picklists_id = 0;
		$scope.ship_by_date = 1;
		$scope.submitted = false;

		//Ship Methods
		datacontext.get_ship_methods().then(function (response) {
			$scope.ship_methods = response.data.data;
		});

		//get previous pick list
		datacontext.get_picklist_type_id({order_id:additem.order_id}).then(function (response) {
			$scope.additem.picklists_id = response.data.data;
		});

		// Reship reasons
		datacontext.get_reship_reasons().then(function (response) {
			$scope.reship_reasons = response.data.data;
		});

		$scope.item = {
	        additem_spid1: ''
	    };

		$scope.isDisabled = true;
    	$scope.isSubmitting = false;

    	$scope.checkInput = function() {
	        if ($scope.item.additem_spid1 && $scope.item.additem_spid1.length > 0) {
	            $scope.isDisabled = false;
	            $scope.error_message =  '';
	        } else {
	            $scope.isDisabled = true;
	        }
	    };

	    // Watch for changes in the input value
	    $scope.$watch('item.additem_spid1', function(newVal, oldVal) {
	        if (newVal !== oldVal) {
	            $scope.checkInput();
	        }
	    });

		$scope.ok = function(item) {
			$scope.submitted = true;

			if(item.additem_spid1 > 0 && item.qty_ordered > 0 && item.price_sold > 0 && item.reship_reason_id > 0) {
				var add_new_item = {
					order_id: additem.order_id,
					store_id: additem.store_id,
					new_spid: item.additem_spid1,
					price_sold: item.price_sold,
					qty_ordered: item.qty_ordered,
					reship_reason_id: item.reship_reason_id
				};

				return datacontext.adjustOrderItems({
					order_id:additem.order_id
					, store_id:additem.store_id
					, store_product_id:item.additem_spid1
					, price_sold:item.price_sold
					, qty_ordered:item.qty_ordered
					, reship_reason_id:item.reship_reason_id
					, cost:0
					, item_tax:0
                    , item_ship_price:0
                    , item_ship_tax:0
                    , item_promo_discount:0
                    , is_packaged:0
				}).then(function (httpResult) {

					if(angular.isDefined(httpResult.data.SFP_ERROR) && httpResult.data.SPID_ERROR.length){
						$scope.error_message = httpResult.data.SPID_ERROR;
					} else {
						var audit_data = {
	                        new_spid_added: item.additem_spid1
	                        , reship_reason_id:item.reship_reason_id
	                        , price_sold:item.price_sold
							, qty_ordered:item.qty_ordered
	                    };

	                    var audit_info = {
	                        audit_subtype_id: 12
	                        , link_id: additem.order_id
	                        , data: angular.toJson(audit_data)
	                    };

	                    datacontext.create_audit_log(audit_info).then(function (httpResult) {});
						$modalInstance.close();
					}					
				});
			} else {
				error('Please select reship reason.');
			}
		}

		$scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
	}
})();

(function () {
    'use strict';
    var controllerId = 'splitModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'reship', splitModalCtrl]);

    function splitModalCtrl(common, datacontext, $scope, $modalInstance, reship) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var error = getLogFn(controllerId,'error');

        // check if items to reship
        // var has_reship_items = 0;
        // var has_reship_new_items = 0;
        // var has_back_stock = 0;
        // Pushes input to scope
        $scope.reship = reship;
        $scope.picklists_id = 0;
        $scope.ship_by_date = 1;
        $scope.submitted = false;
        
        // Ship Methods
        datacontext.get_ship_methods().then(function (response) {
            $scope.ship_methods = response.data.data;
        });

        //get previous pick list
        datacontext.get_picklist_type_id({order_id:reship.order_id}).then(function (response) {
        	$scope.reship.picklists_id = response.data.data;
        });

        //get previous pick pack slip id
        datacontext.get_picklist_slip_id({order_id:reship.order_id}).then(function (response) {
        	$scope.reship.pickpack_slip_id = response.data.data;
        });

        //picklsit types
        datacontext.get_picklists().then(function (response) {
            $scope.picklists = response.data.data;
        });

        // ReShip reasons
        datacontext.get_reship_reasons().then(function (response) {
            $scope.reship_reasons = response.data.data;
        });

        var splitPackageItems = [];
		$scope.isItemPush = function(check_move_new_pkg,order_item_id){
			console.log(check_move_new_pkg);
			console.log(order_item_id);

			if(check_move_new_pkg){
				splitPackageItems.push(order_item_id);
			}else{
				var index = splitPackageItems.indexOf(order_item_id);
				splitPackageItems.splice(index,1);
			}
		}

		$scope.ok = function(reship){
			console.log(reship);
			console.log(splitPackageItems);
			console.log(reship.reship_reason_id);
			console.log(reship.reship_ship_method_id);
			console.log(reship.pickpack_slip_id);
			console.log(reship.picklists_id);
			console.log(reship.order_id);

			splitPackageItems = splitPackageItems.toString();
			console.log(splitPackageItems);
			
			if(reship.ship_by_date == 0 || reship.ship_by_date == 1 && reship.reship_reason_id != "" && reship.reship_reason_id != 0 ) {
            
                var formData = {
                	order_id : reship.order_id,
                	order_package_type_id : 2,
                	order_item_id : splitPackageItems,
                	ship_method_id : reship.reship_ship_method_id,
                	reship_reason_id : reship.reship_reason_id,
                    pickpack_type_id : reship.picklists_id,
                    pickpack_slip_id : reship.pickpack_slip_id,
                    ship_by_date : reship.ship_by_date,
                    reship: 1
                }
    
    			console.log(formData);
                return datacontext.splitOrderPackage(formData).then(function (httpResult) {
                	$modalInstance.close('update');
                });
                $modalInstance.close(); 
            }   
            else{

            	if(reship.ship_by_date == "" && reship.reship_reason_id == ""){
            		$scope.error_message = 'Please Select Reship reason and Ship by date Values';	
            	}else if(reship.ship_by_date == "" && reship.reship_reason_id != ""){
            		$scope.error_message = 'Please Select Ship by date Values';
            	}else if(reship.ship_by_date != "" && reship.reship_reason_id == ""){
            		$scope.error_message = 'Please Select Reship reason';
            	}
                
            }

            $modalInstance.close(); 
		}


        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'orderArchiveCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'order', orderArchiveCtrl]);

    function orderArchiveCtrl(common, datacontext, $scope, $modalInstance, order) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.archive_order = function (order_id) {

            var formData = {
                order_id: order.order_id,
                order_status_id: 2
            };

            return datacontext.updateOrder(formData).then(function (httpResult) {
                $modalInstance.close('update');
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'orderCancelCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'order', orderCancelCtrl]);

    function orderCancelCtrl(common, datacontext, $scope, $modalInstance, order) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.ok = function (order_id) {

            var formData = {
                order_id: order[0].order_id,
                order_status_id: 3
            };

            return datacontext.updateOrder(formData).then(function (httpResult) {
                $modalInstance.close('update');
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'editAddressModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'edit_address', editAddressModalCtrl]);

    function editAddressModalCtrl(common, datacontext, $scope, $modalInstance, edit_address) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.address = edit_address;
        datacontext.get_province_list().then(function (response) {
            $scope.province_list = response.data.data;

        });

        datacontext.get_country_list().then(function (response) {
            $scope.country_list = response.data.data;

        });
        // Ship Methods
        //datacontext.get_customer_address().then(function(response) {
        //    $scope.address = response.data.data;
        //});

        $scope.update_customer_address = function (payload) {

        	var payload = {
             		address_1: edit_address.address_1,
             		first_name: edit_address.first_name,
             		last_name: edit_address.last_name,
             		address_2: edit_address.address_2,
             		address_id: edit_address.address_id,
             		city: edit_address.city,
             		company: edit_address.company,
             		country: edit_address.country,
             		country_code: edit_address.country_code,
             		country_id: edit_address.country_id,
             		is_validated: edit_address.is_validated,
                     order_id: edit_address.order_id,
                     phone_number: edit_address.phone_number,
                     province: edit_address.province,
                     province_code: edit_address.province_code,
                     province_id: edit_address.province_id,
                     province_state: edit_address.province_state,
                     zip: edit_address.zip
                 };


            return datacontext.update_customer_address(payload).then(function (httpResult) {
                $modalInstance.close('update');

            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'editShipServiceModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'edit_ship_service', editShipServiceModalCtrl]);

    function editShipServiceModalCtrl(common, datacontext, $scope, $modalInstance, edit_ship_service) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.edit_ship_service = edit_ship_service;
        console.log("ctrl");
        console.log($scope);
        var payload = {
         		order_id: edit_ship_service.order_id,
         		ship_service_level: edit_ship_service.ship_service_level
             };

        $scope.update_shipping_service = function (payload) {

        	console.log(payload);
            return datacontext.update_shipping_service(payload).then(function (httpResult) {
                $modalInstance.close('update');

            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
(function () {
    'use strict';
    var controllerId = 'endiciaCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$cookies', endiciaCtrl]);

    function endiciaCtrl(common, datacontext, $scope, $cookies) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.endicia_order_export = [];
        vm.export_customs_data = [];
        vm.parsed = 0;

        $scope.flowOptions = {
            target: '/apis/utilities.cfc?method=upload&type=endicia',
            testChunks: false,
            permanentErrors: [404, 500, 501],
            maxChunkRetries: 20,
            chunkRetryInterval: 5000,
            simultaneousUploads: 4,
            singleFile: true,
            headers: {'Authorization': 'Bearer ' + $cookies.get('token')}
        };

        $scope.$on('catchAll', function () {
            //event.preventDefault();//prevent file from uploading
            console.log('catchAll', arguments);
        });

        activate();

        function activate() {
            var promises = [endicia_order_export(), export_customs_data()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        $scope.getExportHeader = function () {
            return [
                "OrderNumber",
                "RubberStamp2",
                "ShipToFirstName",
                "ShipToLastName",
                "ShipToAddress1",
                "ShipToAddress2",
                "ShipToCity",
                "ShipToState",
                "ShipToZip",
                "ShipToCountry",
                "ShipToCompany",
                "Phone",
                "Value"]
        };
        $scope.getCustomExportHeader = function () {
            return [
                "OrderNumber",
                "Description",
                "SalePrice",
                "Country",
                "Quantity",
                "Weight",
                "UnitOfMeasure",
                "CurrencyCode"]
        };

        $scope.uploadResult = function (file, message, flow) {

            // parse json ???
            var msg = JSON.parse(message);
            console.log('msg', msg);
            console.log('file', file);
            console.log('flow', flow);

            vm.parsed = 1;
            $scope.status = msg.success;
            $scope.parsed_cnt = msg.data.parsed;

            $scope.skip_cnt = msg.data.skip_count;
            $scope.skip_details = msg.data.skip_array;

            $scope.error_cnt = msg.data.fail_count;
            $scope.error_details = msg.data.fail_array;
        };

        function endicia_order_export() {
            //todo: run only count on load require click to create file
            return datacontext.endicia_order_export().then(function (httpResult) {
                vm.endicia_order_export = httpResult.data;
                //console.log(vm.endicia_order_export.length);
            });
        }

        function export_customs_data() {
            //todo: run only count on load require click to create file
            return datacontext.export_customs_data().then(function (httpResult) {
                vm.export_customs_data = httpResult.data;
            });
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'fulfillmentStatusModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'fulfillmentStatus', fulfillmentStatusModalCtrl]);

    function fulfillmentStatusModalCtrl(common, datacontext, $scope, $modalInstance, fulfillmentStatus) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);


        $scope.fulfillment_status_id = fulfillmentStatus.fulfillment_status_id;

        // set model fulfillment status

        datacontext.get_fulfillment_status().then(function (response) {
            $scope.order_fulfillment_status = response.data.data;
        });

        $scope.updateFulfillmentStatus = function (id) {

            var formData = {
                order_id: fulfillmentStatus.order_id,
                fulfillment_status_id: id,
                order_note: 'fulfillment_status_id status changed to '+ id+' from Order Details page.'
            };

            return datacontext.updateOrder(formData).then(function () {
                $modalInstance.close('update');
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'financialStatusModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'financialStatus', financialStatusModalCtrl]);

    function financialStatusModalCtrl(common, datacontext, $scope, $modalInstance, financialStatus) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);


        $scope.financial_status_id = financialStatus.financial_status_id;

        // set model Financial status

        datacontext.get_financial_status().then(function (response) {
            $scope.order_financial_status = response.data.data;
        });

        $scope.updateFinancialStatus = function (id) {

            var formData = {
                order_id: financialStatus.order_id,
                financial_status_id: id,
                order_note: 'financial_status_id status changed to '+ id+' from Order Details page.',
                create_order_package: 1
            };

            return datacontext.updateOrder(formData).then(function () {
                $modalInstance.close('update');
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'shipByDateModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'shipByDate', shipByDateModalCtrl]);

    function shipByDateModalCtrl(common, datacontext, $scope, $modalInstance, shipByDate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.ord = shipByDate;
        $scope.ord.mp_ship_latest_by = new Date($scope.ord.mp_ship_latest_by);

        var timestamp = Date.parse($scope.ord.mp_ship_latest_by);
        var isValidDate = !isNaN(timestamp);

        if(! isValidDate){
            $scope.ord.mp_ship_latest_by = NaN;
        }

        $scope.updateShipByDate = function (id) {

            var formData = {
                order_id: shipByDate.order_id,
                mp_ship_latest_by: id,
                order_note: 'ship by date changed to '+ id+' from Order Details page.'
            };

            return datacontext.updateOrder(formData).then(function () {
                $modalInstance.close('update');
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'orderAsinListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$routeParams', 'NgTableParams', orderAsinListCtrl]);

    function orderAsinListCtrl(common, datacontext, $scope, $location, $routeParams, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;

        vm.startSearch = 0;

        vm.orders = [];

        vm.title = 'Order List View';
        vm.query = {
            queryType:'array-count',
            search: "",
            order_by: "",
            order_dir: "",
            page: 1,
            limit: 50
        };
        $("#search_product").focus();
        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
          console.log("i:"+i+", vm.query[i]:"+vm.query[i]+", vm.urlQuery[i]:"+vm.urlQuery[i]);
            if ( i !== 'queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            url_used = 1;
        }
        $(document).on('keypress',function(e) {
          if(e.which == 13) {
            var enterd_val = $('input:text[name=search_enter]').val();
            if(enterd_val.length == 7){
              vm.query.search = enterd_val;
              vm.query.searchtype = 'yoda';
              vm.startSearch ++;
              get_yoda_order_list(enterd_val);
            }
            }
        });
        $scope.lookup_order_mp = function (data) {
        	 vm.query.search = data;
           vm.query.searchtype = 'mp';
           vm.startSearch ++;
           log_success("searching MP Order...");
           get_yoda_order_list(data);
        }

        $scope.lookup_asin = function (data) {
        	//console.log(data);
        	vm.query.search = data;
        	vm.startSearch ++;
          //log("searching asin...");
          log_success("searching asin....");
          console.log("lookup_asin");
        	get_asin_list(data);
        }
        $scope.lookup_title = function (data) {
        	//console.log(data);
        	vm.query.search = data;
        	vm.startSearch ++;
          log_success("searching Title....");
        	get_spid_title(data);
        }

        $scope.lookup_vsku = function (data) {
        	//console.log(data);
          if(angular.isDefined($routeParams.psearch_vsku)){
              data = $routeParams.psearch_vsku;
              vm.query.search = data;
              vm.startSearch ++;
              log_success("searching vendor sku....");
              get_vsku_list(vm.query);

          }else{
            vm.query.search = data;
          	vm.startSearch ++;
            log_success("searching vendor sku....");
          	get_vsku_list(data);
          }

        }

        $scope.lookup_spid = function (data) {
        	if(!isNaN(data)){
        		vm.query.search = data;
            	vm.startSearch ++;
              log_success("searching SPID...");
            	get_spid_list(data);
        	}else{
        		log("Enter only numeric value for SPID search");
        	}

        }

        $scope.lookup_upc = function (data) {
        	if(!isNaN(data)){
        		vm.query.search = data;
            	vm.startSearch ++;
              log_success("searching upc...");
            	get_upc_list(data);
        	}else{
        		log("Enter only numeric value for UPC search");
        	}

        }

        $scope.lookup_fnsku = function (data) {
        	 vm.query.search = data;
           vm.startSearch ++;
           log_success("searching fnsku...");
           get_fnsku_list(data);
        }

        $scope.lookup_order_ebay = function (data) {
        	 vm.query.search = data;
           vm.query.searchtype = 'ebay';
           vm.startSearch ++;
           log_success("searching ebay user...");
           get_yoda_order_list_ebay(data);
        }

        $scope.lookup_order_ebay_recnum = function (data) {
        	 vm.query.search = data;
           vm.query.searchtype = 'ebay_recnum';
           vm.startSearch ++;
           log_success("searching ebay order...");
           get_yoda_order_list_ebay(data);
        }

        $scope.lookup_order = function (data) {

        	vm.query.search = $scope.vm.query.search_order;
        	vm.query.searchtype = data;
        	if(data === 'yoda'){
        		if(!isNaN(vm.query.search)){
                log_success("searching order...");
            		get_yoda_order_list(data);
        		}else{
        			log("Enter only numeric value for order search");
        		}
        	}else{
            log_success("searching order...");
        		get_yoda_order_list(data);
        	}

        }
        $scope.lookup_picklist_id = function (data) {

        	vm.query.pickpack_slip_id = data;
          console.log(vm.query.pickpack_slip_id);
          if(!isNaN(vm.query.pickpack_slip_id)){
            log_success("searching picklist...");
        		datacontext.get_picklist_id(vm.query).then(function (httpResult) {
              console.log(httpResult.data.data);
              //redirect to order page
              if(httpResult.data.data > 0){
                location.href = '#/pickpack/details/'+httpResult.data.data;
              }else{

              }
            });
      		}else{
      			log("Enter only numeric value for pickpack_slip_id");
      		}

        }
        $scope.onsite_by_spid = function (data) {

        	vm.query.spid = data;
          console.log(vm.query.spid);
          if(!isNaN(vm.query.spid)){
            vm.startSearch ++;
            log_success("searching onsite SPID...");
            get_onsite_orders_list(data);
      		}else{
      			log("Enter only numeric value for SPID");
      		}

        }
        $scope.onsite_by_fnsku = function (data) {

        	vm.query.fnsku = data;
          console.log(vm.query.fnsku);
          vm.startSearch ++;
          log_success("searching onsite by fnsku...");
          get_onsite_orders_list(data);

        }



        function get_onsite_orders_list(data){
          vm.query.spid = data;
          vm.tableParamonsite= new NgTableParams({
              count: vm.query.limit // count per page
          }, {
              getData: function(params) {

                  vm.query.page = params.page;
                  //vm.query.search = search;


                  console.log(vm.query);
                  // ajax request to api
                  return datacontext.onsite_by_spid(vm.query).then(function (httpResult) {
                      params.total(httpResult.data.total);
                      vm.results_asin_total = httpResult.data.total;

                      // set new data
                      vm.results_asin = httpResult.data.data;
                      vm.type ='onsite_order';
                      console.log(vm);
                      return vm.results_asin;
                  });
              }
          });
        }

        $scope.lookup_pid = function (data) {
        	if(!isNaN(data)){
        		vm.query.search = data;
            	vm.startSearch ++;
              log_success("searching PID...");
        		get_pid_list(data);
        	}else{
        		log("Enter only numeric value for search PID");
        	}
        }
        $scope.lookup_mpid = function (data) {
          if(angular.isDefined($routeParams.psearch_mpid)){
              data = parseInt($routeParams.psearch_mpid);
              get_mpid_list(data);

          }else if(!isNaN(data)){
              vm.query.search = data;
              vm.startSearch ++;
              log_success("searching MPID...");
              get_mpid_list(data);
          }else{
              log("Enter only numeric value for UPC search");
          }

      }
      $scope.lookup_mparentid = function (data) {
        if(angular.isDefined($routeParams.psearch_mparentid)){
            data = parseInt($routeParams.psearch_mparentid);
            get_mparent_id_list(data);

        }else if(!isNaN(data)){
            vm.query.search = data;
            vm.startSearch ++;
            log_success("searching Master Parent...");
            get_mparent_id_list(data);
        }else{
            log("Enter only numeric value for master parent search");
        }

    }


        activate();

        function activate() {
        	if(angular.isDefined($routeParams.psearch_asin)){
                vm.startSearch ++;
                vm.query.search_product = $routeParams.psearch_asin;
                vm.query.search = $routeParams.psearch_asin;
                log_success("searching asin...");
                console.log("psearch_asin");
                get_asin_list(vm.query);

            }else if(angular.isDefined($routeParams.psearch_mpid)){
            	vm.startSearch ++;
                vm.query.search_product = parseInt($routeParams.psearch_mpid);
                vm.query.search = parseInt($routeParams.psearch_mpid);
                get_mpid_list( vm.query);

            }else if(angular.isDefined($routeParams.psearch_vsku)){
            	vm.startSearch ++;
                //data = $routeParams.psearch_vsku;
                vm.query.search = $routeParams.psearch_vsku;
                get_vsku_list(vm.query.search);

            }else if(angular.isDefined($routeParams.psearch_mparentid)){
            	vm.startSearch ++;
                //data = $routeParams.psearch_vsku;
                vm.query.search = $routeParams.psearch_mparentid;
                get_mparent_id_list(vm.query.search);

            }else{
                var promises = [
                    //get_asin_list(vm.query.search)
                ];
            }
            common.activateController(promises, controllerId)
                .then(function () {
                    //  log('Activated Order List View');
                });
        }

        function get_asin_list() {
          return datacontext.get_asin_list(vm.query).then(function (httpResult) {
              //params.total(httpResult.data.total);
              vm.results_asin_total = httpResult.data.total;
              //redirect to store product
              if(httpResult.data.spid > 0){
                location.href = '#/stores/product/'+httpResult.data.spid;
              }
              // set new data
              vm.results_asin = httpResult.data.data;
              vm.type ='asin';
              return vm.results_asin;
          });

        }
        function get_mparent_id_list() {
          return datacontext.get_mparent_id_list(vm.query).then(function (httpResult) {
              //params.total(httpResult.data.total);
              vm.results_asin_total = httpResult.data.total;

              // set new data
              vm.results_asin = httpResult.data.data;
              vm.type ='mpid1';
              return vm.results_asin;

          });

        }

        function get_spid_title(search) {
            vm.tableParamsspid = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.search = search;


                    console.log(vm.query);
                    // ajax request to api
                    return datacontext.get_spid_title(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_asin_total = httpResult.data.total;
                        //redirect to store product
                        if(httpResult.data.spid > 0){
                        	location.href = '#/stores/product/'+httpResult.data.spid;
                        }
                        // set new data
                        vm.results_title = httpResult.data.data;
                        vm.type ='title';
                        return vm.results_title;
                    });
                }
            });
        }

        function get_mpid_list(search) {
        	console.log(search);
            vm.tableParamspid = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.search = search;


                    console.log(vm.query);
                    // ajax request to api
                    return datacontext.get_mpid_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_asin_total = httpResult.data.total;
                        //redirect to store product
                        if(httpResult.data.spid > 0){
                        	location.href = '#/product/'+httpResult.data.mpid;
                        }
                        // set new data
                        vm.results_asin = httpResult.data.data;
                        vm.type ='mpid';
                        return vm.results_asin;
                    });
                }
            });
        }
        function get_fnsku_list(search) {
        	console.log(search);
            vm.tableParamspid = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.search = search;


                    console.log(vm.query);
                    // ajax request to api
                    return datacontext.get_fnsku_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_asin_total = httpResult.data.total;
                        //redirect to store product
                        if(httpResult.data.fnsku > 0){
                        	location.href = '#/stores/product/'+httpResult.data.fnsku;
                        }
                        // set new data
                        vm.results_asin = httpResult.data.data;
                        vm.type ='fnsku';
                        return vm.results_asin;
                    });
                }
            });
        }

        function get_spid_list(search) {
            vm.tableParamsspid = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.search = search;


                    console.log(vm.query);
                    // ajax request to api
                    return datacontext.get_spid_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_asin_total = httpResult.data.total;
                        //redirect to store product
                        if(httpResult.data.spid > 0){
                        	location.href = '#/stores/product/'+httpResult.data.spid;
                        }
                        // set new data
                        vm.results_asin = httpResult.data.data;
                        vm.type ='spid';
                        return vm.results_asin;
                    });
                }
            });
        }

        function get_upc_list(search) {
            vm.tableParamsspid = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.search = search;


                    console.log(vm.query);
                    // ajax request to api
                    return datacontext.get_upc_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_asin_total = httpResult.data.total;
                        //redirect to store product
                        if(httpResult.data.pid > 0){
                        	location.href = '#/product/'+httpResult.data.pid;
                        }
                        // set new data
                        vm.results_asin = httpResult.data.data;
                        vm.type ='upc';
                        return vm.results_asin;
                    });
                }
            });
        }
        function get_yoda_order_list_ebay() {
            vm.tableParams1 = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    console.log(vm.query);

                    // ajax request to api
                    return datacontext.get_yoda_order_list_ebay(vm.query).then(function (httpResult) {
                    	//redirect to order page
                    	if(httpResult.data.order_id > 0){
                        	location.href = '#/order/'+httpResult.data.order_id;
                        }else{
                        	params.total(httpResult.data.total);
                            vm.results_asin_total = httpResult.data.total;
                        	// set new data
                            vm.results_asin = httpResult.data.data;
                            vm.type ='orderebay';
                            return vm.results_asin;
                        }
                    });
                }
            });
        }
        function get_yoda_order_list() {
            vm.tableParams2 = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    console.log(vm.query);

                    // ajax request to api
                    return datacontext.get_yoda_order_list(vm.query).then(function (httpResult) {
                    	//redirect to order page
                    	if(httpResult.data.order_id > 0){
                        	location.href = '#/order/'+httpResult.data.order_id;
                        }else{
                        	params.total(httpResult.data.total);
                            vm.results_asin_total = httpResult.data.total;
                        	// set new data
                            vm.results_asin = httpResult.data.data;
                            vm.type ='order';
                            if(vm.query.searchtype === 'mp'){
                              vm.search = 'MP Order: '+vm.query.search +'<a href="https://ace.gothamcityonline.com/#/orders/?import_order='+vm.query.search+'" target="_blank"> Import here</a>';
                            }else{
                              vm.search = 'Yoda Order: '+vm.query.search;
                            }

                            console.log(vm.search);
                            console.log(vm.query);
                            return vm.results_asin;
                        }
                    });
                }
            });
        }

        function get_pid_list() {
            vm.tableParamspid = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    console.log(vm.query);

                    // ajax request to api
                    return datacontext.get_pid_list(vm.query).then(function (httpResult) {
                    	//redirect to order page
                    	if(httpResult.data.pid > 0){
                        	location.href = '#/product/'+httpResult.data.pid;
                        }else{
                        	params.total(httpResult.data.total);
                            vm.results_asin_total = httpResult.data.total;
                        	// set new data
                            vm.results_asin = httpResult.data.data;
                            vm.type ='pid';
                            return vm.results_asin;
                        }
                    });
                }
            });
        }

        function get_vsku_list() {
            vm.tableParamsvsku = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }


                    // ajax request to api
                    return datacontext.get_vsku_list(vm.query).then(function (httpResult) {
                    	//redirect to order page
                    	if(httpResult.data.vsku > 0){
                        	location.href = '#/vendor/product/'+httpResult.data.vsku;
                        }else{
                        	params.total(httpResult.data.total);
                            vm.results_asin_total = httpResult.data.total;
                        	// set new data
                            vm.results_asin = httpResult.data.data;
                            vm.type ='vsku';
                            return vm.results_asin;
                        }
                    });
                }
            });
        }
    }
})();


(function () {
    'use strict';
    var controllerId = 'cancelOrderctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'cancelOrder', cancelOrderctrl]);

    function cancelOrderctrl(common, datacontext, $scope, $modalInstance, cancelOrder) {
        var getLogFn = common.logger.getLogFn;
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        // Pushes input to scope
        $scope.cancel_order = cancelOrder;
        $scope.qty_refunded = [];
        $scope.qty_ordered = [];
        $scope.order_item_id = [];
        $scope.store_product_id = [];
        $scope.product_id = [];
        $scope.temp_qty_ordered = [];
        $scope.temp_order_item_id = [];
        $scope.temp_store_product_id = [];
        $scope.temp_product_id = [];
        $scope.click = 0;

        var formData = {};
        formData.cancelOrder_id = cancelOrder.marketplace_order_id;
        formData.store_id = cancelOrder.store_id;

        angular.forEach($scope.cancel_order.items, function (item,key) {
            $scope.temp_qty_ordered[key] = item.qty_ordered;
            $scope.temp_order_item_id[key] = item.order_item_id;
            $scope.temp_store_product_id[key] = item.store_product_id;
            $scope.temp_product_id[key] = item.product_id;
        });

         $scope.isCancelClick = function (idx,id) {

            if ( $scope.qty_refunded[idx] === undefined ) {
                $scope.click = $scope.click + 1;
                $scope.qty_refunded[idx] = id;
                $scope.order_item_id[idx] = $scope.temp_order_item_id[idx];
                $scope.qty_ordered[idx] = $scope.temp_qty_ordered[idx];
                $scope.store_product_id[idx] = $scope.temp_store_product_id[idx];
                $scope.product_id[idx] = $scope.temp_product_id[idx];
            } else {
                $scope.click = $scope.click - 1;
                $scope.qty_refunded[idx] = undefined;
                $scope.order_item_id[idx] = undefined;
                $scope.qty_ordered[idx] = undefined;
                $scope.store_product_id[idx] = undefined;
                $scope.product_id[idx] = undefined;
            }

        };

         $scope.removeUndefined = function (item) {
            var temp_array = [];
            for (var i = 0; i < item.length; i++) {
              if (item[i] !== undefined && item[i] !== null && item[i] !== "") {
                temp_array.push(item[i]);
              }
             }
             return temp_array;
         };

           $scope.ok = function () {

            $scope.qty_refunded = $scope.removeUndefined($scope.qty_refunded);
            $scope.order_item_id = $scope.removeUndefined($scope.order_item_id);
            $scope.qty_ordered = $scope.removeUndefined($scope.qty_ordered);
            $scope.store_product_id = $scope.removeUndefined($scope.store_product_id);
            $scope.product_id = $scope.removeUndefined($scope.product_id);

            var formData = {};
            formData.cancelOrder_id = $scope.cancel_order.marketplace_order_id;
            formData.order_id = $scope.cancel_order.order_id;
            formData.store_id = $scope.cancel_order.store_id;
            formData.jet_def_order_id = $scope.cancel_order.jet_def_order_id;

            angular.forEach($scope.qty_refunded, function (item,key) {
                        formData.mp_order_item_id = item;
                        formData.order_item_id = $scope.order_item_id[key];
                        formData.qty_refunded = $scope.qty_ordered[key];
                        formData.check = key;
                        formData.store_product_id = $scope.store_product_id[key];
                        formData.product_id = $scope.product_id[key];

                   return  datacontext.cancelOrder(formData).then(function (httpResult) {

                    if(httpResult.data.data == 1){
                        log_success("Cancelled");
                    }
                    else{
                        log_error("Failed");
                        if(httpResult.data.data != 0){
                            log_error(httpResult.data.data);
                        }
                    }

                    });

            });

            $scope.$broadcast('refreshAuditLog', 'refresh');
            $modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'importAmazonOrderctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'mp_order', importAmazonOrderctrl]);

    function importAmazonOrderctrl(common, datacontext, $scope, $modalInstance, mp_order) {
        var getLogFn = common.logger.getLogFn;
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        $scope.data = {order_id : mp_order};
//$scope.data.order_id = $scope.import_order;
        console.log($scope);
        $scope.order_id = "";
        $scope.store_id = "";
        $scope.imported = 0;
        $scope.resetImportOrder = function (){
          $scope.data = {order_id : '', store_id : 0, src : ''};
          $scope.imported = 0;
          console.log($scope);
        };
        $scope.ok = function (order_id,store_id,src) {



            if(angular.isDefined(src)){
              console.log(src);
            }else{
              //src = "fba1";
            }
            if(!(angular.isDefined(src))){
              $scope.message = "Please select fulfill type!";
            }else if(angular.isDefined(src) && src == 'fba1'){
              $scope.imported = 1;
              $scope.message = "";
              log_success('Importing');
              datacontext.importAmazonMissedOnsiteOrder({orderid:order_id,store_id:store_id}).then(function (httpResult) {
                  //$scope.created_order = httpResult.data;
              	console.log(httpResult);

                  if( httpResult.data.match("ERROR") ){
                      $scope.imported = 2;
                      //console.log(httpResult.data.Error.Code);
                      //console.log(httpResult.data.Error.Message);
                      $scope.created_order = "Error while Importing, developer will get an email with details";
                      return "";
                  }else if (httpResult.data.match("order already imported") || httpResult.data.match("This order previously imported") ){
                  	$scope.imported = 2;
                  	$scope.created_order = httpResult.data;
                  }else{
                  	datacontext.parseAmazonMissedOrder({orderid:order_id,src:'fba1',store_id:store_id}).then(function (httpResult) {
                          $scope.imported = 2;
                          $scope.created_order = httpResult.data;
                      });
                  }

              });
            }else if(angular.isDefined(src)){
              $scope.imported = 1;
              log_success('Importing');
              $scope.message = "";
              datacontext.importAmazonMissedOrder({orderid:order_id,store_id:store_id}).then(function (httpResult) {
                  //$scope.created_order = httpResult.data;
              	console.log(httpResult);

                  if( httpResult.data.match("ERROR") ){
                      $scope.imported = 2;
                      $scope.created_order = "Error while Importing, developer will get an email with details";
                      return "";
                  }else if (httpResult.data.match("order already imported") || httpResult.data.match("This order previously imported") ){
                  	$scope.imported = 2;
                  	$scope.created_order = httpResult.data;
                  }else{
                  	//datacontext.parseAmazonMissedOrder({orderid:order_id,src:src,store_id:store_id}).then(function (httpResult) {
                          $scope.imported = 2;
                          $scope.created_order = httpResult.data;
                    //});
                  }

              });
            }


            //$scope.$broadcast('refreshAuditLog', 'refresh');
            //$modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'importWalmartOrderctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', importWalmartOrderctrl]);

    function importWalmartOrderctrl(common, datacontext, $scope, $modalInstance) {
        var getLogFn = common.logger.getLogFn;
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        $scope.order_id = "";
        $scope.store_id = "";
        $scope.imported = 0;

        $scope.ok = function (order_id,store_id) {

            $scope.imported = 1;
            log_success('Importing');
            datacontext.importWalmartMissedOrder({orderid:order_id}).then(function (httpResult) {
                //$scope.created_order = httpResult.data;
            	console.log(httpResult);

                if( httpResult.data.match("ERROR") ){
                    $scope.imported = 2;
                    $scope.created_order = "Error while Importing, developer will get an email with details";
                    return "";
                }else if (httpResult.data.match("order already imported") ){
                	$scope.imported = 2;
                	$scope.created_order = httpResult.data;
                }else{
                	$scope.imported = 2;
                    $scope.created_order = httpResult.data;

                }

            });

            //$scope.$broadcast('refreshAuditLog', 'refresh');
            //$modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
  'use strict';
    var controllerId = 'createManualOrderctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', createManualOrderctrl]);

    function createManualOrderctrl(common, datacontext, $scope, $modalInstance) {
      var getLogFn = common.logger.getLogFn;
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        $scope.order_id = "";
        $scope.store_id = "";
        $scope.imported = 0;

        //set order defaults
        $scope.ord = {
          order_id: "",
          store_id: "",
          email: "",
          first_name: "",
          state: "",
          address1: "",
          address2: "",
          city: "",
          postalCode: "",
          phone: "",
          store_product_id: "",
          price_sold: "",
          quantity: "",
          order_date: "",
          ship_paid: "",
          shipping_price: "",
          shipping_tax: "",
          tax: "",
          order_total: "",
          ship_service_level: "",
          purchase_order_id: "",
          mp_ship_latest_by: "",
          order_notes: ""
        }

        $scope.ok = function (order_id,store_id) {
          $scope.imported = 1;
          log_success('Importing');

            datacontext.createMissedOrder({orderid:order_id,storeid:store_id}).then(function (httpResult) {
              console.log(httpResult);
              console.log(httpResult.data);

                if( httpResult.data.match("ERROR") ){
                    $scope.imported = 2;
                    $scope.created_order = "Error while Importing, developer will get an email with details";
                    return "";
                }else if (httpResult.data.match("order already imported") ){
                  $scope.imported = 2;
                  $scope.created_order = httpResult.data;
                }else{
                  $scope.imported = 2;
                  $scope.created_order = httpResult.data;
                  $scope.ord.order_id = order_id;
                  $scope.ord.store_id = store_id;
                }
            });
        };

        // Create manual order
        $scope.create_manual_order = function(isValid) {
            $scope.submitted = 1;
            console.log($scope.ord);

            if (isValid) {
                // Create order
                datacontext.createmanualorder($scope.ord).then(function (httpResult) {
                   console.log(httpResult.data);
                });
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'shippingupdateCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', shippingupdateCtrl]);

    function shippingupdateCtrl(common, datacontext, $scope, $location) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.query = {
        		note:'',
        		ship_method_id: 0,
        		pickslip_id: 0
            };

        vm.startSearch = 0;
        console.log("test");
        //activate();
        datacontext.get_pickpack_types().then(function(httpResult) {
        	$scope.pickpack_types = httpResult.data.data;
        });

        datacontext.get_ship_methods().then(function (httpResult) {
    		vm.ship_methods = httpResult.data.data;
    		$scope.ship_methods = vm.ship_methods;
    	});

        $scope.update_shipping = function (data) {
        	vm.query.note = data.note;
        	vm.query.ship_method_id = data.ship_method_id;
        	vm.query.pickslip_id = data.pickslip_id;
        	datacontext.update_ship_method(vm.query).then(function (httpResult) {
        		vm.ship_methods = httpResult.data.data;
	    		$scope.ship_methods = vm.ship_methods;
	    	});
        }



    }
})();
